import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthGuard } from '../components';
import MainLayout from './MainLayout';
import useActivityTracker from '@hooks/useActivityTracker';

const ProtectedLayout: FC = () => {
  useActivityTracker();

  return (
    <MainLayout>
      <AuthGuard>
        <Outlet />
      </AuthGuard>
    </MainLayout>
  );
};

export default ProtectedLayout;
